module.exports = __webpack_public_path__ + "front/img/39.b00519e9.jpg";